import { Header } from "../../../../components/atoms";
import { BookingAddressForm } from "../../../../components/organisms/booking-group/address";
import { Checkout } from "../../../../components/organisms/booking-group/checkout";
import {
  OrderSummaryContainer,
  PromocodeContainer,
} from "../../../../containers/booking";
import { LoginRegistrationContainer } from "../../../../containers/booking/login-registration";
import { Column, Container, Row } from "../../../grid";
import { metaData } from "../../../../static/meta";
import * as React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router";

import { IService } from "../../../../services/api/therapists";
import { IRootState } from "../../../../store/index";

interface IProps {
  path: string;
}

interface IReduxProps {
  treatments: { [urn: string]: IService };
}

type Props = IProps & IReduxProps & RouteComponentProps;

const CheckoutPageHeaderRow = Row.extend`
  margin-bottom: 30px;

  @media screen and (max-width: 992px) {
    margin-bottom: 0;
  }
`;

const CheckoutPageSummaryColumn = Column.extend`
  padding-left: 100px;

  @media screen and (max-width: 992px) {
    order: -1;
  }
`;

const CheckoutPageBookingRow = Row.extend`
  @media screen and (max-width: 992px) {
    flex-direction: column-reverse;
    margin-bottom: 50px;

    ${CheckoutPageSummaryColumn} {
      padding: 0 5%;
    }
  }
`;

class CheckoutPage extends React.Component<Props> {
  /**
   * No need to render more then once
   */
  public shouldComponentUpdate() {
    return false;
  }

  /**
   * Render checkout page with store
   */
  public render() {
    return Object.keys(this.props.treatments).length ? (
      <Container offsetPaddings>
        <Helmet>
          <title>{metaData.checkout.title}</title>
          <meta name="description" content={metaData.checkout.description} />
        </Helmet>
        <CheckoutPageHeaderRow>
          <Column textAlign="center">
            <Header>Review & Checkout</Header>
          </Column>
        </CheckoutPageHeaderRow>
        <CheckoutPageBookingRow>
          <Column md="7">
            <Switch>
              <Route exact path={"/booking"} render={() => <Checkout />} />
              <Route
                path={`/booking/login`}
                render={() => (
                  <LoginRegistrationContainer
                    loggedInRoute="/booking"
                    loggedOutRoute="/booking/login"
                  />
                )}
              />
              <Route
                path={`/booking/address-form`}
                render={() => <BookingAddressForm />}
              />
            </Switch>
          </Column>
          <CheckoutPageSummaryColumn md="5">
            <OrderSummaryContainer />
            <Switch>
              <Route exact path={"/booking"}>
                <PromocodeContainer />
              </Route>
            </Switch>
          </CheckoutPageSummaryColumn>
        </CheckoutPageBookingRow>
      </Container>
    ) : (
      <Redirect to="/" />
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    treatments: state.treatmentsState.treatments,
  };
};

const store = withRouter(
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(CheckoutPage),
);

export { store as CheckoutPage };
